module.exports = __webpack_public_path__ + "static/media/occasions-deliciousness.5c28ebfa.jpg";